export class SnsGovernanceError extends Error {}
